"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactRedux = require("react-redux");

var _underscore = require("underscore");

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIFullScreen = _interopRequireDefault(require("UIComponents/dialog/UIFullScreen"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _Subscriptions = require("lead-flows-ui/actions/Subscriptions");

var _ErrorUtils = require("lead-flows-ui/utils/ErrorUtils");

var _SimpleDialog = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleDialog"));

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var EspSyncModal = _react.default.createClass({
  displayName: "EspSyncModal",
  propTypes: (0, _extends2.default)({}, _PromptablePropInterface.default, {
    dispatch: _react.default.PropTypes.func.isRequired,
    subscriptions: _react.default.PropTypes.object.isRequired,
    espName: _react.default.PropTypes.string.isRequired,
    formGuid: _react.default.PropTypes.string.isRequired,
    className: _react.default.PropTypes.string,
    onConfirm: _react.default.PropTypes.func.isRequired,
    onReject: _react.default.PropTypes.func.isRequired
  }),
  getDefaultProps: function getDefaultProps() {
    return {
      espName: function espName() {
        return _I18n.default.text('unknown');
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      changes: {}
    };
  },
  componentWillMount: function componentWillMount() {
    this.props.dispatch((0, _Subscriptions.fetchSubscriptionsIfNeeded)(this.props.formGuid));
  },
  componentDidMount: function componentDidMount() {
    (0, _eventsTrackerUtils.trackEditorInteraction)('open-esp-list-modal');
  },
  langKey: function langKey(suffix) {
    return "espSyncModal." + suffix;
  },
  getConfirmAction: function getConfirmAction(hasConfigurationError) {
    if (hasConfigurationError) {
      return this.goToEmailSyncSettings;
    }

    return this.handleSave;
  },
  handleSave: function handleSave() {
    var _this$props = this.props,
        dispatch = _this$props.dispatch,
        onConfirm = _this$props.onConfirm,
        formGuid = _this$props.formGuid;
    var changes = this.state.changes;
    var changedKeys = Object.keys(changes || {});
    (0, _underscore.each)(changedKeys, function (espListId) {
      dispatch((0, _Subscriptions.updateSubscriptionEnabled)(formGuid, espListId, changes[espListId]));
    });
    dispatch((0, _Subscriptions.saveSubscriptions)(formGuid, changedKeys)).then(function () {
      (0, _eventsTrackerUtils.trackEditorInteraction)('save-esp-list-connection');
      onConfirm();
    }, function () {// swallow error: we don't want to close and it isn't reportable
    }).done();
  },
  goToEmailSyncSettings: function goToEmailSyncSettings() {
    window.location = '#/settings/emailSync';
  },
  handleCheckboxChange: function handleCheckboxChange(listId, enabled) {
    var changed = {};
    changed[listId] = enabled;
    this.setState({
      changes: Object.assign({}, this.state.changes, changed)
    });
  },
  getConfirmButtonText: function getConfirmButtonText(isSaving, hasConfigurationError) {
    var saveButtonText;

    if (isSaving) {
      saveButtonText = 'saving';
    } else if (hasConfigurationError) {
      saveButtonText = 'goToSettings';
    } else {
      saveButtonText = 'save';
    }

    return saveButtonText;
  },
  getErrorBody: function getErrorBody(error, espName, hasConfigurationError) {
    var errorBody;

    if (hasConfigurationError) {
      errorBody = _react.default.createElement("div", null, _react.default.createElement("h4", {
        className: "leadinModal__error-header"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('errorWithConfig'),
        options: {
          espName: espName
        }
      })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('adjustConfig'),
        options: {
          espName: espName
        }
      })));
    } else {
      var errorMessage = (0, _ErrorUtils.parseResponseJson)(error.response).message;
      errorBody = _react.default.createElement("div", null, _react.default.createElement("h4", {
        className: "leadinModal__error-header"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: 'thereWasAnError'
      })), _react.default.createElement("p", null, errorMessage));
    }

    return errorBody;
  },
  renderModalBody: function renderModalBody(isFetching, fetchingHasError, fetchingRecentError, espName, subscriptionsByEspListId, hasConfigurationError) {
    var _this = this;

    var content;

    if (isFetching || !espName) {
      content = _react.default.createElement(_UILoadingSpinner.default, {
        grow: true,
        minHeight: 50
      });
    } else if (fetchingHasError) {
      content = this.getErrorBody(fetchingRecentError, espName, hasConfigurationError);
    } else {
      var subscriptions = Object.values(subscriptionsByEspListId || {});

      if (subscriptions.length < 1) {
        // TODO: we need to link to how to create a new doc
        content = _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('noListsMessage'),
          options: {
            espName: espName
          }
        }));
      } else {
        content = (0, _underscore.map)(subscriptions, function (list) {
          return _react.default.createElement("div", {
            className: "form-input-group",
            key: "esp-sync-list-" + list.espListId
          }, _react.default.createElement(_UICheckbox.default, {
            defaultChecked: list.syncEnabled,
            onChange: function onChange(_ref) {
              var checked = _ref.target.checked;
              return _this.handleCheckboxChange(list.espListId, checked);
            }
          }, list.name));
        });
      }
    }

    return content;
  },
  renderSavingErrorComponent: function renderSavingErrorComponent(savingHasError, savingRecentError) {
    if (savingHasError) {
      return _react.default.createElement("p", null, _react.default.createElement("strong", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('errorSavingChanges')
      })), savingRecentError.message);
    }

    return null;
  },
  render: function render() {
    var _this$props2 = this.props,
        espName = _this$props2.espName,
        formGuid = _this$props2.formGuid,
        onReject = _this$props2.onReject,
        className = _this$props2.className;
    var _this$props$subscript = this.props.subscriptions,
        isFetching = _this$props$subscript.isFetching,
        fetchingHasError = _this$props$subscript.fetchingHasError,
        fetchingRecentError = _this$props$subscript.fetchingRecentError,
        subscriptionsByFormGuid = _this$props$subscript.subscriptionsByFormGuid,
        isSaving = _this$props$subscript.isSaving,
        savingHasError = _this$props$subscript.savingHasError,
        savingRecentError = _this$props$subscript.savingRecentError;

    var _ref2 = subscriptionsByFormGuid[formGuid] || {},
        subscriptionsByEspListId = _ref2.subscriptionsByEspListId;

    var hasConfigurationError = fetchingHasError && fetchingRecentError.status === 403;
    var modalBody = this.renderModalBody(isFetching, fetchingHasError, fetchingRecentError, espName, subscriptionsByEspListId, hasConfigurationError);
    var errorContent = this.renderSavingErrorComponent(savingHasError, savingRecentError);
    var confirmAction = this.getConfirmAction(hasConfigurationError);
    var confirmButtonText = this.getConfirmButtonText(isSaving, hasConfigurationError);
    var saveButtonDisabled = isSaving;
    return _react.default.createElement(_UIFullScreen.default, null, _react.default.createElement(_SimpleDialog.default, {
      className: className,
      headerText: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('pushToEsp'),
        options: {
          espName: espName
        }
      }),
      onConfirm: confirmAction,
      onReject: onReject,
      primaryText: _react.default.createElement(_FormattedMessage.default, {
        message: confirmButtonText
      }),
      confirmDisabled: saveButtonDisabled,
      secondaryText: _react.default.createElement(_FormattedMessage.default, {
        message: 'cancel'
      }),
      contextual: false
    }, _react.default.createElement("div", null, modalBody, errorContent)));
  }
});

function mapStateToProps(state, ownProps) {
  return Object.assign({}, {
    subscriptions: state.subscriptions
  }, ownProps);
}

var _default = (0, _reactRedux.connect)(mapStateToProps)(EspSyncModal);

exports.default = _default;
module.exports = exports.default;